var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDvtBenefits2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 461,
    height: 311,
    viewBox: "0 0 461 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_837_236)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 453,
    height: 303,
    rx: 8,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_837_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.121 269.383L94.202 296.106C92.9243 297.383 90.8511 297.385 89.5709 296.104L50.0907 256.624C48.8115 255.344 48.814 253.273 50.0912 251.995L78.1634 223.922C79.4431 222.643 81.5153 222.641 82.794 223.92L121.379 261.847C121.379 261.847 123.912 264.146 122.987 266.895C122.777 267.519 121.121 269.383 121.121 269.383Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6456 246.622L72.1323 270.135",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6455 257.593L77.6179 275.621",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.16 241.137L66.6472 264.65",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6752 235.652L61.1619 259.165",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.858 263.999C98.1704 265.827 94.8381 267.822 94.6616 267.957C91.3624 270.482 92.7819 273.847 92.7819 273.847C93.5338 277.982 94.9754 283.232 94.9995 283.244C96.2757 283.877 98.1534 282.406 98.204 279.876C98.225 278.833 97.7945 276.228 97.7945 274.223C97.7945 274.04 97.7153 272.658 98.3779 272.242C99.6546 271.438 102.682 271.842 102.682 271.842C102.682 271.842 103.398 280.352 104.572 281.683C108.557 286.202 108.988 281.354 108.988 281.354L111.248 278.873C114.361 278.887 116.854 278.873 119.374 278.873C125.565 278.873 126.374 275.562 126.374 275.562H136.538L136.573 262.416L108.717 262.417C108.717 262.417 105.026 262.429 101.858 263.999Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.345 279.325L110.179 283.342C110.179 283.342 112.337 284.723 113.866 282.387C114.784 280.985 116.951 277.398 116.951 277.398C116.951 277.398 118.452 275.216 116.539 274.02C114.592 272.8 110.827 271.09 110.827 271.09L103.345 279.325Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.009 280.815L105.94 282.744C106.817 283.371 107.82 283.747 109.052 282.556C110.301 281.349 111.133 280.237 111.133 280.237C111.133 280.237 113.491 277.76 111.668 275.957C109.724 274.035 108.061 275.382 108.061 275.382L106.203 275.737L102.369 279.779C102.602 280.156 102.822 280.511 103.009 280.815Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9253 288.66C93.9233 288.665 93.9208 288.669 93.9183 288.674C93.2772 289.919 92.9098 291.008 93.0978 291.105C93.2862 291.202 93.9589 290.27 94.6 289.024C94.602 289.02 94.604 289.016 94.606 289.012L93.9253 288.66Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.182 263.788C104.495 263.874 104.835 263.732 104.989 263.432C105.13 263.158 105.07 262.837 104.868 262.626L110.239 253.522C110.414 253.225 110.791 253.116 111.098 253.274L112.002 253.74L112.501 252.773L110.661 251.826C110.508 251.748 112.674 251.472 112.511 251.524C112.346 251.576 109.863 251.952 109.784 252.107L103.959 263.427C103.932 263.478 103.927 263.539 103.945 263.594C103.963 263.65 104.002 263.696 104.054 263.723L104.182 263.788Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.024 263.699C104.034 263.707 104.042 263.717 104.054 263.723L104.182 263.789C104.495 263.874 104.834 263.732 104.989 263.433C105.13 263.159 105.07 262.836 104.868 262.627L110.24 253.522C110.415 253.226 110.792 253.117 111.099 253.275L112.002 253.739L112.251 253.256L110.852 252.536C110.566 252.389 110.214 252.496 110.058 252.777L104.024 263.699Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9 250.41C112.979 250.257 113.116 250.141 113.281 250.088C113.446 250.035 113.624 250.05 113.778 250.129L114.423 250.461C114.742 250.625 114.868 251.018 114.704 251.338L112.575 255.474L110.772 254.545L112.9 250.41Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1319 290.019C94.2427 290.076 94.3756 290.071 94.4818 290.005L95.3966 289.435C95.6247 289.293 95.8096 289.092 95.9324 288.854L114.23 253.298C114.278 253.205 114.286 253.099 114.255 252.999C114.223 252.901 114.153 252.819 114.061 252.771L112.107 251.766C111.915 251.668 111.68 251.743 111.581 251.935L93.2833 287.489C93.16 287.728 93.1044 287.996 93.1214 288.264L93.1901 289.34C93.1981 289.464 93.2708 289.575 93.3816 289.633L94.1319 290.019Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3881 274.835C99.5826 274.455 100.047 274.306 100.427 274.502L102.34 275.487C102.718 275.682 102.868 276.146 102.672 276.524L96.7159 288.099C96.5209 288.478 96.0562 288.627 95.6773 288.432L93.764 287.447C93.3851 287.252 93.2362 286.788 93.4312 286.409L99.3881 274.835Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5614 279.066C98.7249 278.749 99.1138 278.624 99.4311 278.788C99.7484 278.951 99.8727 279.34 99.7098 279.656C99.5464 279.974 99.1574 280.099 98.8396 279.936C98.5223 279.772 98.398 279.383 98.5614 279.066Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.602 262.569C112.832 262.82 106.996 268.217 104.921 271.207L98.2657 280.204C98.2657 280.204 97.8862 281.744 99.8677 282.915C102.23 284.311 104.768 281.473 105.105 281.107C107.262 278.765 111.145 274.411 111.145 274.411H119.198C119.198 274.411 125.256 274.288 126.366 270.406",
    fill: "#E8F2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.602 262.569C112.832 262.82 106.996 268.217 104.921 271.207L98.2657 280.204C98.2657 280.204 97.8862 281.744 99.8677 282.915C102.23 284.311 104.768 281.473 105.105 281.107C107.262 278.765 111.145 274.411 111.145 274.411H119.198C119.198 274.411 125.256 274.288 126.366 270.406",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.676 277.952C136.676 278.207 136.471 278.412 136.216 278.411L128.981 278.388C128.728 278.387 128.522 278.181 128.523 277.927L128.572 261.864C128.573 261.612 128.78 261.405 129.033 261.406L136.268 261.427C136.523 261.428 136.726 261.636 136.726 261.889L136.676 277.952Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.378 276.104C175.238 281.241 171.047 281.029 167.343 281.022L135.079 280.989C134.826 280.989 134.62 280.783 134.622 280.529L134.68 261.388C134.681 261.135 134.888 260.93 135.14 260.93L161.704 260.957L200.426 227.982L210.117 249.369L181.378 276.104Z",
    fill: "#3561E4",
    stroke: "#010200",
    strokeWidth: 1.50376
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.858 263.999C98.1704 265.827 94.8381 267.822 94.6616 267.957C91.3624 270.482 92.7819 273.847 92.7819 273.847C93.5338 277.982 94.9754 283.232 94.9995 283.244C96.2757 283.877 98.1534 282.406 98.204 279.876C98.225 278.833 97.7945 276.228 97.7945 274.223C97.7945 274.04 97.7153 272.658 98.3779 272.242C99.6546 271.438 102.682 271.842 102.682 271.842C102.682 271.842 103.398 280.352 104.572 281.683C108.557 286.202 108.988 281.354 108.988 281.354L111.248 278.873C114.361 278.887 116.854 278.873 119.374 278.873C125.565 278.873 126.374 275.562 126.374 275.562H136.538L136.573 262.416L108.717 262.417C108.717 262.417 105.026 262.429 101.858 263.999Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.345 279.325L110.179 283.342C110.179 283.342 112.337 284.723 113.866 282.387C114.784 280.985 116.951 277.398 116.951 277.398C116.951 277.398 118.452 275.216 116.539 274.02C114.592 272.8 110.827 271.09 110.827 271.09L103.345 279.325Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.009 280.815L105.94 282.744C106.817 283.371 107.82 283.747 109.052 282.556C110.301 281.349 111.133 280.237 111.133 280.237C111.133 280.237 113.491 277.76 111.668 275.957C109.724 274.035 108.061 275.382 108.061 275.382L106.203 275.737L102.369 279.779C102.602 280.156 102.822 280.511 103.009 280.815Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9253 288.66C93.9233 288.665 93.9208 288.669 93.9183 288.674C93.2772 289.919 92.9098 291.008 93.0978 291.105C93.2862 291.202 93.9589 290.27 94.6 289.024C94.602 289.02 94.604 289.016 94.606 289.012L93.9253 288.66Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.182 263.788C104.495 263.874 104.835 263.732 104.989 263.432C105.13 263.158 105.07 262.837 104.868 262.626L110.239 253.522C110.414 253.225 110.791 253.116 111.098 253.274L112.002 253.74L112.501 252.773L110.661 251.826C110.508 251.748 112.674 251.472 112.511 251.524C112.346 251.576 109.863 251.952 109.784 252.107L103.959 263.427C103.932 263.478 103.927 263.539 103.945 263.594C103.963 263.65 104.002 263.696 104.054 263.723L104.182 263.788Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.024 263.699C104.034 263.707 104.042 263.717 104.054 263.723L104.182 263.789C104.495 263.874 104.834 263.732 104.989 263.433C105.13 263.159 105.07 262.836 104.868 262.627L110.24 253.522C110.415 253.226 110.792 253.117 111.099 253.275L112.002 253.739L112.251 253.256L110.852 252.536C110.566 252.389 110.214 252.496 110.058 252.777L104.024 263.699Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.9 250.41C112.979 250.257 113.116 250.141 113.281 250.088C113.446 250.035 113.624 250.05 113.778 250.129L114.423 250.461C114.742 250.625 114.868 251.018 114.704 251.338L112.575 255.474L110.772 254.545L112.9 250.41Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1319 290.019C94.2427 290.076 94.3756 290.071 94.4818 290.005L95.3966 289.435C95.6247 289.293 95.8096 289.092 95.9324 288.854L114.23 253.298C114.278 253.205 114.286 253.099 114.255 252.999C114.223 252.901 114.153 252.819 114.061 252.771L112.107 251.766C111.915 251.668 111.68 251.743 111.581 251.935L93.2833 287.489C93.16 287.728 93.1044 287.996 93.1214 288.264L93.1901 289.34C93.1981 289.464 93.2708 289.575 93.3816 289.633L94.1319 290.019Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.3881 274.835C99.5826 274.455 100.047 274.306 100.427 274.502L102.34 275.487C102.718 275.682 102.868 276.146 102.672 276.524L96.7159 288.099C96.5209 288.478 96.0562 288.627 95.6773 288.432L93.764 287.447C93.3851 287.252 93.2362 286.788 93.4312 286.409L99.3881 274.835Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5614 279.066C98.7249 278.749 99.1138 278.624 99.4311 278.788C99.7484 278.951 99.8727 279.34 99.7098 279.656C99.5464 279.974 99.1574 280.099 98.8396 279.936C98.5223 279.772 98.398 279.383 98.5614 279.066Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.602 262.569C112.832 262.82 106.996 268.217 104.921 271.207L98.2657 280.204C98.2657 280.204 97.8862 281.744 99.8677 282.915C102.23 284.311 104.768 281.473 105.105 281.107C107.262 278.765 111.145 274.411 111.145 274.411H119.198C119.198 274.411 125.256 274.288 126.366 270.406",
    fill: "#E8F2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.602 262.569C112.832 262.82 106.996 268.217 104.921 271.207L98.2657 280.204C98.2657 280.204 97.8862 281.744 99.8677 282.915C102.23 284.311 104.768 281.473 105.105 281.107C107.262 278.765 111.145 274.411 111.145 274.411H119.198C119.198 274.411 125.256 274.288 126.366 270.406",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.676 277.952C136.676 278.207 136.471 278.412 136.216 278.411L128.981 278.388C128.728 278.387 128.522 278.181 128.523 277.927L128.572 261.864C128.573 261.612 128.78 261.405 129.033 261.406L136.268 261.427C136.523 261.428 136.726 261.636 136.726 261.889L136.676 277.952Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.585 275.157C356.585 275.157 360.359 270.284 361.617 269.107C362.873 267.928 358.243 265.876 355.17 269.658C353.13 272.172 352.264 274.685 352.264 274.685L346.918 278.852L356.585 275.157Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.266 271.384C363.266 271.384 367.313 267.044 368.296 265.333C369.155 263.841 364.923 262.104 361.852 265.885C359.809 268.4 358.942 270.914 358.942 270.914L353.6 275.08L363.266 271.384Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.476 266.97C365.794 267.928 361.978 271.62 361.301 271.935C358.942 273.035 355.014 274.058 350.927 273.506C350.925 273.506 350.924 273.506 350.922 273.506C349.212 273.265 347.784 272.87 343.931 271.751C347.048 270.665 354.058 267.984 355.093 265.491C356.43 262.269 354.227 260.303 350.926 262.505C348.177 264.338 345.739 265.177 339.767 265.099C332.908 265.008 332.143 265.649 330.729 266.592C330.518 266.732 330.327 266.907 330.153 267.102L322.498 265.338L320.852 277.317L345.135 282.906C345.135 282.906 348.594 284.072 351.333 283.316C352.032 283.124 352.903 282.662 353.806 282.089C355.292 281.375 363.292 277.533 365.307 276.571C366.958 275.785 372.878 268.535 373.168 268.163C373.852 267.288 372.286 264.234 367.476 266.97Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.142 266.023C323.144 265.77 323.348 265.582 323.602 265.585H330.763C331.018 265.586 331.273 265.772 331.273 266.023V282.034C331.27 282.287 331.015 282.498 330.763 282.496H323.602C323.348 282.494 323.142 282.288 323.142 282.034V266.023Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.301 223.471L295.912 262.951H324.736C324.988 262.951 325.194 263.202 325.191 263.453V282.534C325.191 282.788 324.927 282.991 324.674 282.991H290.078C290.078 282.991 287.511 282.947 284.967 281.76C281.727 280.248 279.712 278.16 279.712 278.16L253.559 249.43L261.301 223.471Z",
    fill: "#3561E4",
    stroke: "#010200",
    strokeWidth: 1.50376
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M200.426 227.982L161.704 260.957L156.755 260.952C160.035 265.15 162.683 268.03 164.837 270.088C168.239 273.338 176.7 276.438 182.715 270.255C186.544 266.319 200.484 248.596 200.484 248.596C200.5 248.452 200.509 252.353 200.512 258.304L210.117 249.37L200.426 227.982Z",
    fill: "#010200"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.17,
    d: "M295.912 262.95L261.301 223.471L253.559 249.429L267.509 264.754V243.784C267.509 243.21 268.276 243.57 268.343 244.15L282.687 263.981C288.978 270.797 292.657 272.26 302.682 262.95H295.912V262.95Z",
    fill: "#010200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.038 200.604C329.038 200.604 341.146 197.416 340.855 205.546C340.519 214.955 333.125 224.701 326.069 227.053C319.012 229.406 315.651 231.086 315.651 231.086L309.938 221.677L329.038 200.604Z",
    fill: "white",
    stroke: "#020500",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.738 185.983H424.125C421.704 180.258 416.218 176.134 409.738 175.67V185.983Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.841 175.649C401.125 175.917 395.402 180.1 392.914 185.983H407.841V175.649Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.789 187.881H409.738V198.443H424.395C425.078 196.608 425.452 194.626 425.452 192.557C425.452 190.934 425.217 189.367 424.789 187.881Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.841 187.881H392.248C391.821 189.367 391.586 190.934 391.586 192.557C391.586 194.626 391.96 196.608 392.643 198.443H407.841V187.881Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.841 200.339H393.487C396.212 205.582 401.597 209.22 407.841 209.467V200.339Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.738 200.339V209.449C415.752 209.017 420.904 205.431 423.551 200.339H409.738Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.519 209.492C402.59 209.492 397.765 201.894 397.765 192.557C397.765 183.22 402.59 175.624 408.519 175.624C414.449 175.624 419.274 183.22 419.274 192.557C419.274 201.894 414.449 209.492 408.519 209.492ZM408.519 177.52C403.635 177.52 399.663 184.266 399.663 192.557C399.663 200.85 403.635 207.594 408.519 207.594C413.404 207.594 417.376 200.85 417.376 192.557C417.376 184.266 413.404 177.52 408.519 177.52Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.453 156.082C328.453 153.963 326.843 152.222 324.778 152.015C324.525 148.015 321.201 144.846 317.135 144.846C313.687 144.846 310.772 147.124 309.812 150.257C307.291 150.497 305.319 152.617 305.319 155.2C305.319 157.944 307.542 160.167 310.287 160.167C310.298 160.167 310.31 160.166 310.322 160.166V160.167H324.384C326.633 160.158 328.453 158.334 328.453 156.082Z",
    fill: "#D5E3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.378 143.74L304.592 190.526L342.079 228.012L388.864 181.227L351.378 143.74Z",
    fill: "white",
    stroke: "#020500",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.248 214.531L318.252 186.535L347.748 157.039",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.328 177.293L324.233 186.387L328.577 190.732L337.672 181.637L333.328 177.293Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.661 186.48L330.993 193.148L335.339 197.494L342.007 190.826L337.661 186.48Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.063 189.6L337.755 199.908L342.1 204.254L352.408 193.946L348.063 189.6Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.485 192.714L344.54 206.661L348.888 211.008L362.833 197.061L358.485 192.714Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.391 186.985L371.256 182.482L360.39 177.977C360.39 185.066 360.39 179.914 360.391 186.985Z",
    fill: "#D8DBD7",
    stroke: "#010200",
    strokeWidth: 1.50376
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.142 173.411L347.544 173.412L347.543 182.318L360.013 182.317",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5574 160.637H85.6386C87.5343 160.637 89.0717 159.099 89.0717 157.202V131.557H52.1233V157.202C52.1233 159.099 53.6606 160.637 55.5574 160.637Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0717 127.123C89.0717 125.226 87.5348 123.689 85.6386 123.689H55.5574C53.6606 123.689 52.1228 125.225 52.1228 127.123V131.558H89.0712L89.0717 127.123Z",
    fill: "#3B94EC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6792 140.368C66.0015 137.258 70.1043 141.218 67.6742 144.367C66.8441 145.443 65.7794 146.702 63.4376 149.25L63.3414 149.302H68.5414",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6792 140.368C66.0015 137.258 70.1043 141.218 67.6742 144.367C66.8441 145.443 65.7795 146.702 63.4376 149.25L63.3414 149.302H68.5414",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5688 139.366H78.426V141.18C76.1257 143.875 75.0225 146.853 74.7523 149.302",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5688 139.366H78.426V141.18C76.1257 143.875 75.0225 146.853 74.7523 149.302",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6385 160.637C87.5342 160.637 89.0716 159.099 89.0716 157.203V150.552L78.9858 160.637H85.6385Z",
    fill: "#3B94EC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1394 150.467C80.7595 150.467 78.8281 152.396 78.8281 154.777V160.637H78.975L89.0717 150.539V150.466L83.1394 150.467Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.511 203.513C123.43 200.252 122.372 190.487 122.372 190.487C122.513 189.434 123.237 187.374 125.12 187.426C127.036 187.478 128.058 191.305 128.058 191.305C128.144 189.874 128.103 184.921 130.979 185.38C133.053 185.712 133.108 187.913 133.108 187.913C133.108 187.913 133.415 186.397 135.091 186.506C137.111 186.642 137.157 189.512 137.157 189.512L137.342 191.315C137.342 191.315 137.657 190.099 139.338 190.367C140.863 190.61 140.954 193.098 140.954 193.098L141.901 203.577C143.737 205.929 144.403 206.813 145.882 208.726C149.512 213.42 147.476 215.975 147.476 215.975L153.436 223.684L142.705 232.024L126.369 210.897C126.369 210.897 123.616 207.788 123.511 203.513Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.50376
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.46 164.084L97.801 176.965L123.255 209.884L139.914 197.003L114.46 164.084Z",
    fill: "#D8DBD7",
    stroke: "#010200",
    strokeWidth: 1.50376
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.286 195.742L113.952 169.444L103.418 177.588L123.753 203.887L134.286 195.742Z",
    fill: "#E8F2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.228 179.395C117.216 176.311 122.95 177.045 126.034 181.034C129.117 185.02 128.382 190.753 124.394 193.836C120.406 196.92 114.674 196.188 111.591 192.202C108.506 188.213 109.24 182.478 113.228 179.395Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.181 187.278C124.188 186.499 124.51 185.027 123.511 183.736L122.802 182.82C120.752 180.168 116.274 182.96 118.692 185.997L119.314 186.982C121.42 189.655 117.327 192.877 115.206 190.158L114.497 189.242C113.434 187.865 113.74 186.419 114.766 185.626",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.381 174.778C111.317 174.055 112.663 174.228 113.385 175.161C114.11 176.098 113.935 177.442 113 178.165C112.065 178.888 110.722 178.718 109.997 177.78C109.276 176.847 109.446 175.502 110.381 174.778Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.514 194.884C129.237 195.819 129.065 197.166 128.128 197.89C127.193 198.613 125.851 198.438 125.127 197.502C123.398 195.267 126.782 192.645 128.514 194.884Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.204 190.133L123.689 182.799",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.454 164.776L119.174 206.051L140.062 208.723L145.342 167.449L124.454 164.776Z",
    fill: "#3381E0",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.973 203.844L141.19 170.871L127.983 169.182L123.765 202.155L136.973 203.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.703 176.92C138.967 177.593 142.688 182.406 142.015 187.671C141.341 192.931 136.528 196.652 131.265 195.978C126.003 195.304 122.279 190.493 122.953 185.233C123.626 179.967 128.441 176.246 133.703 176.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.244 190.194C136.573 190.364 137.908 189.509 138.125 187.805L138.28 186.593C138.727 183.095 133.316 181.839 132.855 185.899L132.586 187.096C132.163 190.652 126.72 190.003 127.164 186.402L127.319 185.191C127.551 183.376 128.856 182.528 130.21 182.701",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.244 190.194C136.573 190.364 137.908 189.509 138.125 187.805L138.28 186.593C138.727 183.095 133.316 181.839 132.855 185.899L132.586 187.096C132.163 190.652 126.72 190.003 127.164 186.402L127.319 185.191C127.551 183.376 128.856 182.528 130.21 182.701",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.894 172.117C136.066 172.268 136.897 173.342 136.747 174.512C136.597 175.686 135.523 176.514 134.351 176.363C133.177 176.213 132.349 175.143 132.5 173.968C132.649 172.799 133.721 171.968 134.894 172.117Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.498 199.157C133.349 200.329 132.274 201.159 131.1 201.009C129.928 200.859 129.102 199.786 129.252 198.614C129.611 195.808 133.858 196.347 133.498 199.157Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.493 185.509L139.965 187.361",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.371 210.646L132.531 197.276C132.531 197.276 132.685 194.483 135.273 194.769C137.471 195.014 138.006 197.309 137.914 198.846L137.699 208.403L140.813 212.431C140.813 212.431 143.06 214.841 142.897 216.779C142.791 218.019 142.437 219 141.979 219.671",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.371 210.646L132.531 197.276C132.531 197.276 132.685 194.483 135.273 194.769C137.471 195.014 138.006 197.309 137.914 198.846L137.699 208.403L140.813 212.431C140.813 212.431 143.06 214.841 142.897 216.779C142.791 218.019 142.437 219 141.979 219.671",
    stroke: "black",
    strokeWidth: 1.50376
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.162 209.487C282.951 203.448 277.974 198.689 271.643 197.51L248.757 194.102C246.736 193.787 245.156 191.706 245.129 189.536L244.629 177.352C221.194 177.352 246.324 177.352 222.633 177.352L222.12 189.959C222.018 192.001 220.49 193.696 218.469 194.011L195.873 197.51C189.54 198.689 184.562 203.447 183.351 209.487C183.351 209.487 198.977 231.52 200.484 231.558C201.06 231.57 200.484 232.037 200.484 232.616V287.787C207.271 287.787 259.363 287.787 266.152 287.787C266.152 229.072 265.679 231.557 267.215 231.619C267.825 231.641 268.332 232.109 268.401 232.719L284.162 209.487Z",
    fill: "white",
    stroke: "#020500",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.914 214.564L238.076 210.19L233.683 202.506L229.184 210.19C232.312 216.601 231.969 215.512 231.693 216.921L229.174 229.852L233.578 234.535V234.665L233.63 234.598L233.683 234.665V234.535L238.171 229.852C235.353 215.561 235.189 216.003 235.914 214.564Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.15 188.38L216.792 193.811L227.16 211.328C227.874 212.547 228.445 212.473 229.088 211.257L233.664 201.749C220.534 186.583 221.119 186.446 220.15 188.38Z",
    fill: "white",
    stroke: "#020500",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.11 188.38L250.468 193.811L240.103 211.328C239.388 212.547 238.817 212.473 238.171 211.257L233.594 201.749C246.787 186.511 246.152 186.469 247.11 188.38Z",
    fill: "white",
    stroke: "#020500",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.396 210.677C283.737 202.063 280.124 198.316 273.642 197.32L260.279 195.413L235.917 229.068C235.007 230.832 232.483 230.832 231.574 229.068L207.22 195.413L193.859 197.32C186.97 198.316 183.203 201.364 181.092 210.677L170.09 244.55C170.09 244.55 150.466 215.263 150.342 215.139C149.739 214.536 135.272 224.461 135.646 224.968C138.094 228.29 157.326 256.264 165.194 263.782C168.595 267.033 175.134 269.558 180.754 265.531C185.217 262.333 200.483 241.578 200.483 241.578C200.55 240.998 200.483 305.938 200.483 306.513C200.35 306.513 200.496 306.513 204.752 306.513H265.827C266.663 306.513 267.465 306.513 267.508 306.513V236.767C267.508 236.192 268.275 236.553 268.342 237.133L282.687 256.964C288.981 263.783 293.996 268.216 305.241 255.915C310.443 250.225 316.933 242.442 323.044 232.766L309.714 220.2L294.815 238.816L286.396 210.677Z",
    fill: "#3561E4",
    stroke: "#010200",
    strokeWidth: 1.50376
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5128 215.034C68.5128 225.14 60.3234 229.528 50.2181 229.528C40.1113 229.528 31.9224 225.14 31.9224 215.034C31.9224 204.929 40.1113 192.937 50.2181 192.937C60.3229 192.937 68.5128 204.928 68.5128 215.034Z",
    fill: "white",
    stroke: "#020500",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5579 193.096C57.5579 193.895 56.9098 194.541 56.1108 194.541H44.3218C43.5238 194.541 42.8782 193.895 42.8782 193.096C42.8782 192.3 43.5238 191.653 44.3218 191.653H56.1108C56.9093 191.653 57.5579 192.3 57.5579 193.096Z",
    fill: "#3B94EC",
    stroke: "#010200",
    strokeWidth: 1.50376
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6206 183.167C61.3328 183.182 61.0847 183.224 60.9318 183.306C59.7514 183.948 58.1143 182.966 56.0146 182.966C53.9148 182.966 52.8792 183.948 51.6988 183.306C51.374 183.13 50.6441 182.826 50.2176 182.826C49.7905 182.826 49.0602 183.13 48.7359 183.306C47.5554 183.948 45.9158 182.966 43.8161 182.966C41.7188 182.966 40.6837 183.948 39.5028 183.306C39.3504 183.224 39.1018 183.182 38.8146 183.167C37.9213 183.118 37.611 184.255 38.2186 184.912L44.4406 191.652H55.994L62.2156 184.912C62.8236 184.255 62.5133 183.119 61.6206 183.167Z",
    fill: "white",
    stroke: "#020500",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2295 210.371V204.815C53.3097 204.815 54.205 205.901 54.205 207.269H56.4586C56.4586 204.759 54.6095 202.564 51.23 202.564V200.88H48.9779V202.564C42.3067 202.598 42.3253 212.685 48.9779 212.648V218.202C47.1273 218.202 46.1904 217.079 46.1904 215.748H43.9363C43.9363 218.217 45.8095 220.458 48.9779 220.458V222.139H51.23V220.458C57.6982 220.458 58.7864 210.314 51.2295 210.371ZM48.9774 204.817V210.396C45.3654 210.469 45.206 204.857 48.9774 204.817ZM51.2295 218.203V212.626C55.7749 212.561 54.818 218.203 51.2295 218.203Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.903 221.072C310.903 221.072 313.299 211.931 314.979 208.57C316.66 205.211 318.833 205.069 323.548 204.956C326.63 204.882 334.139 205.136 334.139 205.136C334.139 205.136 335.103 210.301 331.07 210.972C327.038 211.645 321.7 211.931 321.7 211.931C321.7 211.931 324.389 214.62 322.708 218.316C321.028 222.013 315.065 224.692 315.065 224.692L310.903 221.072Z",
    fill: "white",
    stroke: "#020500",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.82 156.034L253.206 156.123C255.284 156.699 257.532 158.661 257.004 161.828C256.529 164.705 256.299 164.949 255.712 168.52C254.884 173.575 250.752 171.928 250.752 171.928L251.82 156.034Z",
    fill: "white",
    stroke: "#020500",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.242 156.034L213.861 156.123C211.779 156.699 209.536 158.661 210.06 161.828C210.537 164.705 210.767 164.949 211.354 168.52C212.182 173.575 216.314 171.928 216.314 171.928L215.242 156.034Z",
    fill: "white",
    stroke: "#020500",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.416 141.318V141.326L216.38 141.396C216.38 176.282 215.588 176.434 218.751 179.723C226.684 187.972 225.459 187.646 233.558 187.646V187.642C237.156 187.642 240.195 188.077 242.986 185.171C248.197 179.744 250.592 178.108 250.592 173.826V141.392L233.416 141.318Z",
    fill: "white",
    stroke: "#020500",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.416 161.143V149.83C217.364 145.905 220.081 141.947 224.402 141.885H231.649C233.847 142.692 231.68 147.552 233.864 146.712L245.893 141.767C248.24 141.264 249.585 143.298 249.585 145.191V161.008C249.585 161.663 253.17 159.913 254.049 156.185L255.62 133.974C255.676 130.959 254.803 127.993 250.592 127.993C250.592 127.993 228.224 127.995 228.226 127.995C217.628 127.811 209.644 132.978 211.425 144.367L213.454 156.991C213.824 159.912 217.416 161.724 217.416 161.143Z",
    fill: "#3B94EC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.379 145.297C405.379 140.054 409.632 135.799 414.875 135.799C420.123 135.799 424.376 140.054 424.376 145.297V149.938C424.376 155.183 420.123 159.438 414.875 159.438C409.632 159.438 405.379 155.183 405.379 149.938V145.297Z",
    fill: "#DDDDDD",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.862 154.825C409.616 154.825 405.35 150.559 405.35 145.315C405.35 140.067 409.617 135.799 414.862 135.799C420.106 135.799 424.375 140.068 424.375 145.315C424.375 150.559 420.106 154.825 414.862 154.825Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.537 118.37H362.114V143.886H412.537V118.37Z",
    fill: "#3381E0",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.991 139.426H408.274V123.293H366.991V139.426Z",
    fill: "#E8F2FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.277 131.357C397.277 136.64 392.993 140.925 387.709 140.925C382.426 140.925 378.145 136.64 378.145 131.357C378.145 126.074 382.426 121.788 387.709 121.788C392.993 121.788 397.277 126.074 397.277 131.357Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.36 134.556C384.36 135.891 385.373 137.1 387.084 137.1H388.3C391.812 137.1 392.368 131.596 388.3 131.655L387.084 131.54C383.519 131.572 383.472 126.114 387.084 126.097H388.3C390.123 126.097 391.126 127.279 391.126 128.639",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.36 134.556C384.36 135.891 385.373 137.1 387.084 137.1H388.3C391.812 137.1 392.368 131.596 388.3 131.655L387.084 131.54C383.519 131.572 383.472 126.114 387.084 126.097H388.3C390.123 126.097 391.126 127.279 391.126 128.639",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.306 132.051C405.306 133.483 404.142 134.645 402.713 134.645C401.278 134.645 400.118 133.483 400.118 132.051C400.118 130.618 401.278 129.457 402.713 129.457C404.142 129.457 405.306 130.617 405.306 132.051Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.593 134.529C371.16 134.529 369.997 133.366 369.997 131.932C369.997 130.5 371.159 129.342 372.593 129.342C376.019 129.342 376.024 134.529 372.593 134.529Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.754 124.334V138.861",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.379 135.815C405.379 130.57 409.632 126.317 414.875 126.317C420.123 126.317 424.376 130.57 424.376 135.815V140.456C424.376 145.701 420.123 149.956 414.875 149.956C409.632 149.956 405.379 145.701 405.379 140.456V135.815Z",
    fill: "#DDDDDD",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.862 145.343C409.616 145.343 405.35 141.077 405.35 135.833C405.35 130.584 409.617 126.316 414.862 126.316C420.106 126.316 424.375 130.585 424.375 135.833C424.375 141.077 420.106 145.343 414.862 145.343Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.116 138.337C417.116 137.851 416.933 137.474 416.567 137.205C416.201 136.936 415.563 136.705 414.654 136.51C413.744 136.316 413.021 136.083 412.487 135.811C411.953 135.538 411.558 135.215 411.302 134.839C411.046 134.464 410.918 134.017 410.918 133.499C410.918 132.637 411.283 131.909 412.011 131.313C412.74 130.717 413.671 130.419 414.804 130.419C415.996 130.419 416.962 130.727 417.704 131.342C418.445 131.958 418.816 132.744 418.816 133.703H417.009C417.009 133.211 416.801 132.786 416.383 132.43C415.965 132.074 415.439 131.896 414.804 131.896C414.15 131.896 413.639 132.039 413.27 132.324C412.9 132.609 412.715 132.981 412.715 133.441C412.715 133.875 412.887 134.202 413.23 134.423C413.573 134.643 414.193 134.853 415.091 135.054C415.987 135.255 416.714 135.495 417.272 135.773C417.829 136.052 418.242 136.387 418.511 136.779C418.779 137.17 418.914 137.648 418.914 138.212C418.914 139.151 418.538 139.904 417.787 140.47C417.036 141.037 416.061 141.32 414.863 141.32C414.02 141.32 413.276 141.171 412.629 140.873C411.981 140.575 411.474 140.159 411.108 139.625C410.742 139.091 410.559 138.512 410.559 137.891H412.356C412.389 138.493 412.63 138.97 413.08 139.323C413.53 139.677 414.124 139.853 414.863 139.853C415.543 139.853 416.088 139.716 416.5 139.441C416.91 139.164 417.116 138.797 417.116 138.337Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.932 129.817V141.999",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9904 187.215H75.8877",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9904 211.708H75.8877",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8371 200.844C86.2336 200.6 85.7664 200.063 85.7664 199.413C85.7664 198.762 86.2336 198.225 86.8371 197.982C89.2396 197.011 90.9353 194.656 90.9353 191.905V187.253H77.822V191.905C77.822 194.64 79.4982 196.978 81.8772 197.962C82.4807 198.21 82.9363 198.761 82.9363 199.413C82.9363 200.065 82.4807 200.616 81.8772 200.865C79.4982 201.847 77.823 204.189 77.823 206.923V211.574H90.9353V206.923C90.9353 204.171 89.2396 201.817 86.8371 200.844Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0171 210.619L84.3439 206.245L89.7244 210.619",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.227 124.586C126.227 123.887 126.793 123.321 127.493 123.321H149.159C149.859 123.321 150.424 123.887 150.424 124.586V155.267C150.424 155.965 149.858 156.533 149.159 156.533H127.493C126.793 156.533 126.227 155.964 126.227 155.267V124.586Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.824 132.353C147.824 132.527 147.683 132.668 147.51 132.668H129.142C128.968 132.668 128.827 132.527 128.827 132.353V126.058C128.827 125.884 128.968 125.741 129.142 125.741H147.51C147.683 125.741 147.824 125.884 147.824 126.058V132.353Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.733 137.98C140.733 138.116 140.622 138.223 140.488 138.223H136.379C136.244 138.223 136.134 138.115 136.134 137.98V135.829C136.134 135.694 136.244 135.585 136.379 135.585H140.488C140.622 135.585 140.733 135.695 140.733 135.829V137.98Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.039 137.98C148.039 138.116 147.928 138.223 147.795 138.223H143.685C143.55 138.223 143.44 138.115 143.44 137.98V135.829C143.44 135.694 143.551 135.585 143.685 135.585H147.795C147.929 135.585 148.039 135.695 148.039 135.829V137.98Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.427 137.98C133.427 138.116 133.318 138.223 133.182 138.223H129.072C128.938 138.223 128.83 138.115 128.83 137.98V135.829C128.83 135.694 128.938 135.585 129.072 135.585H133.182C133.318 135.585 133.427 135.695 133.427 135.829V137.98Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.733 143.159C140.733 143.293 140.622 143.404 140.488 143.404H136.379C136.244 143.404 136.134 143.293 136.134 143.159V141.009C136.134 140.874 136.244 140.764 136.379 140.764H140.488C140.622 140.764 140.733 140.875 140.733 141.009V143.159Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.039 143.159C148.039 143.293 147.928 143.404 147.795 143.404H143.685C143.55 143.404 143.44 143.293 143.44 143.159V141.009C143.44 140.874 143.551 140.764 143.685 140.764H147.795C147.929 140.764 148.039 140.875 148.039 141.009V143.159Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.427 143.159C133.427 143.293 133.318 143.404 133.182 143.404H129.072C128.938 143.404 128.83 143.293 128.83 143.159V141.009C128.83 140.874 128.938 140.764 129.072 140.764H133.182C133.318 140.764 133.427 140.875 133.427 141.009V143.159Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.733 148.545C140.733 148.681 140.622 148.79 140.488 148.79H136.379C136.244 148.79 136.134 148.681 136.134 148.545V146.397C136.134 146.26 136.244 146.151 136.379 146.151H140.488C140.622 146.151 140.733 146.261 140.733 146.397V148.545Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.039 148.545C148.039 148.681 147.928 148.79 147.795 148.79H143.685C143.55 148.79 143.44 148.681 143.44 148.545V146.397C143.44 146.26 143.551 146.151 143.685 146.151H147.795C147.929 146.151 148.039 146.261 148.039 146.397V148.545Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.427 148.545C133.427 148.681 133.318 148.79 133.182 148.79H129.072C128.938 148.79 128.83 148.681 128.83 148.545V146.397C128.83 146.26 128.938 146.151 129.072 146.151H133.182C133.318 146.151 133.427 146.261 133.427 146.397V148.545Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.427 153.798C133.427 153.934 133.318 154.042 133.182 154.042H129.072C128.938 154.042 128.83 153.933 128.83 153.798V151.649C128.83 151.513 128.938 151.405 129.072 151.405H133.182C133.318 151.405 133.427 151.513 133.427 151.649V153.798Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.055 153.798C148.055 153.934 147.946 154.042 147.81 154.042H136.436C136.303 154.042 136.193 153.933 136.193 153.798V151.649C136.193 151.513 136.303 151.405 136.436 151.405H147.81C147.946 151.405 148.055 151.513 148.055 151.649V153.798Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0983 294.526C65.2807 294.997 65.812 295.233 66.2852 295.049C66.7684 294.862 67.0161 294.322 66.8286 293.839C66.7273 293.579 66.8055 293.282 67.0246 293.107C67.3188 292.873 67.5825 292.61 67.8135 292.321C67.9905 292.101 68.2842 291.993 68.5404 292.105C69.0145 292.313 69.5724 292.108 69.781 291.634C69.988 291.163 69.7739 290.612 69.3043 290.407C69.0291 290.283 68.8742 289.989 68.9058 289.691C68.9439 289.342 68.9459 288.986 68.9093 288.631C68.8807 288.352 69.0196 288.073 69.2802 287.971C69.7654 287.782 70.0211 287.244 69.8296 286.758C69.6451 286.28 69.1058 286.042 68.6271 286.229C68.3614 286.331 68.0506 286.265 67.8767 286.039C67.6471 285.74 67.3895 285.474 67.1063 285.238C66.8907 285.059 66.782 284.766 66.8958 284.509C67.1033 284.037 66.8932 283.484 66.4211 283.276C65.9509 283.068 65.401 283.282 65.1935 283.752C65.0827 284.002 64.8201 284.15 64.5504 284.114C64.1479 284.058 63.7353 284.051 63.3218 284.095C63.0697 284.122 62.8346 283.969 62.7434 283.733C62.5614 283.267 62.0356 283.034 61.5674 283.215L61.5293 283.231C61.0592 283.414 60.8246 283.942 61.0075 284.412C61.1058 284.664 60.996 284.943 60.7805 285.107C60.4451 285.363 60.1469 285.659 59.8877 285.982C59.7359 286.175 59.4692 286.237 59.2416 286.138C58.7985 285.941 58.2787 286.143 58.0837 286.587L58.0461 286.671C57.8481 287.122 58.0531 287.648 58.5023 287.847C58.7454 287.953 58.8647 288.224 58.8301 288.485C58.776 288.898 58.7714 289.322 58.8246 289.745C58.8541 289.993 58.7183 290.236 58.4867 290.326C58.0381 290.501 57.814 291.005 57.99 291.454L58.0241 291.544C58.202 292.005 58.7208 292.232 59.182 292.054C59.4156 291.963 59.6822 292.029 59.8341 292.228C60.1023 292.578 60.413 292.888 60.7534 293.152C60.9539 293.306 61.0296 293.576 60.9263 293.807C60.7293 294.254 60.9333 294.779 61.381 294.975L61.4331 294.999C61.8973 295.204 62.4381 294.992 62.6441 294.528C62.7514 294.285 63.0145 294.15 63.2792 294.18C63.6852 294.229 64.1008 294.227 64.5153 294.171C64.7694 294.138 65.0065 294.291 65.0983 294.526ZM62.1113 289.848C61.7198 288.884 62.1855 287.782 63.1519 287.388C64.1188 286.998 65.2206 287.464 65.6115 288.43C66.003 289.397 65.5379 290.499 64.5704 290.89C63.605 291.282 62.5023 290.817 62.1113 289.848Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.795 289.913C45.7057 290.421 46.0451 290.903 46.5513 290.99C47.0581 291.079 47.5408 290.74 47.63 290.233L47.7243 289.685C47.7794 289.372 48.0651 289.158 48.3834 289.155C48.7694 289.148 49.1503 289.115 49.5238 289.056C49.825 289.007 50.1123 289.19 50.2185 289.475L50.405 289.985C50.5824 290.468 51.1168 290.716 51.6 290.539C52.0827 290.362 52.3303 289.827 52.1539 289.345L51.9724 288.851C51.8636 288.554 52.0055 288.228 52.2787 288.068C52.6115 287.872 52.9313 287.654 53.2326 287.415C53.4747 287.221 53.82 287.23 54.0576 287.427L54.4331 287.742C54.827 288.071 55.4145 288.019 55.7438 287.624C56.0742 287.23 56.0215 286.643 55.6275 286.313L55.2792 286.023C55.0356 285.818 54.998 285.464 55.1574 285.19C55.3534 284.853 55.5253 284.5 55.6727 284.131C55.7894 283.841 56.0912 283.661 56.4005 283.715L56.8005 283.785C57.3067 283.874 57.7894 283.534 57.8772 283.028C57.9659 282.52 57.626 282.039 57.1203 281.951L56.7629 281.888C56.4616 281.836 56.2376 281.577 56.2416 281.274C56.2466 280.852 56.219 280.434 56.1589 280.025C56.1128 279.71 56.2772 279.392 56.5759 279.283L56.8706 279.173C57.3539 278.997 57.602 278.464 57.426 277.979C57.2486 277.496 56.7138 277.249 56.232 277.426L55.9674 277.521C55.6822 277.626 55.3584 277.516 55.2085 277.251C54.9995 276.882 54.7609 276.529 54.4947 276.197C54.2942 275.943 54.2646 275.581 54.4732 275.332L54.628 275.146C54.9569 274.753 54.9057 274.163 54.5118 273.834C54.1168 273.506 53.5288 273.557 53.1995 273.951L53.0571 274.123C52.8621 274.356 52.5288 274.425 52.2636 274.272C51.8802 274.05 51.4737 273.857 51.0481 273.698C50.7589 273.59 50.5819 273.291 50.6361 272.984L50.6716 272.779C50.7604 272.273 50.421 271.789 49.9143 271.702C49.4065 271.613 48.9238 271.953 48.8371 272.46L48.8005 272.666C48.7478 272.969 48.4827 273.194 48.1739 273.196C47.7383 273.202 47.3118 273.242 46.8922 273.314C46.5744 273.369 46.2486 273.217 46.1373 272.916L46.0626 272.707C45.8857 272.226 45.3493 271.977 44.8671 272.153C44.3829 272.331 44.1353 272.866 44.3128 273.348L44.3965 273.576C44.5027 273.865 44.3955 274.19 44.1333 274.349C43.7694 274.571 43.4235 274.82 43.0997 275.094C42.8551 275.302 42.4952 275.337 42.2471 275.13L42.031 274.952C41.6371 274.621 41.0506 274.674 40.7213 275.069C40.3909 275.462 40.4436 276.049 40.8371 276.378L41.0802 276.58C41.3273 276.788 41.3659 277.147 41.214 277.434C41.029 277.783 40.8671 278.152 40.7333 278.534C40.6295 278.831 40.3348 279.025 40.0235 278.971L39.6641 278.907C39.1579 278.819 38.6767 279.159 38.5874 279.666C38.4992 280.172 38.8386 280.654 39.3443 280.742L39.7443 280.812C40.0641 280.868 40.2772 281.161 40.2882 281.488C40.3037 281.883 40.3483 282.273 40.4205 282.656C40.4777 282.957 40.3067 283.256 40.018 283.362L39.5925 283.517C39.1102 283.696 38.8621 284.23 39.0381 284.712C39.216 285.196 39.7503 285.443 40.2326 285.266L40.6922 285.098C40.993 284.989 41.3233 285.124 41.4917 285.394C41.6962 285.723 41.9248 286.035 42.1744 286.331C42.3719 286.565 42.3694 286.909 42.1729 287.144L41.8371 287.547C41.5067 287.941 41.5594 288.528 41.9529 288.858C42.3478 289.187 42.9348 289.134 43.2656 288.741L43.6145 288.324C43.8155 288.084 44.1639 288.031 44.4396 288.181C44.7729 288.362 45.1208 288.52 45.4817 288.654C45.7709 288.761 45.9418 289.062 45.8887 289.364L45.795 289.913ZM45.431 280.731C45.7077 279.144 47.2195 278.082 48.8065 278.357C50.393 278.634 51.4576 280.145 51.1799 281.733C50.9037 283.321 49.3914 284.384 47.804 284.107C46.217 283.83 45.1554 282.318 45.431 280.731Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.782 240.369C390.549 240.601 390.151 240.448 390.135 240.119L385.15 224.805L400.467 229.778C400.797 229.799 400.949 230.201 400.714 230.437L396.621 233.321L400.815 237.516C401.149 237.85 401.148 238.39 400.815 238.724L398.969 240.569C398.636 240.904 398.095 240.904 397.761 240.569L393.567 236.375L390.782 240.369Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.371 155.124C265.175 155.124 264.98 155.045 264.837 154.89C264.564 154.595 264.582 154.135 264.877 153.862L279.019 140.774C279.161 140.642 279.35 140.572 279.544 140.58C279.737 140.589 279.92 140.674 280.051 140.817L290.625 152.397L314.138 127.456C314.41 127.167 314.863 127.15 315.156 127.416L324.517 135.915L341.493 117.999C341.77 117.707 342.23 117.695 342.521 117.971C342.813 118.247 342.826 118.708 342.549 119L325.084 137.433C324.813 137.72 324.361 137.737 324.067 137.47L314.707 128.973L291.145 153.965C291.008 154.112 290.817 154.194 290.616 154.194C290.614 154.194 290.612 154.194 290.61 154.194C290.408 154.192 290.215 154.106 290.078 153.956L279.47 142.338L265.865 154.929C265.725 155.06 265.547 155.124 265.371 155.124Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.264 125.492C342.862 125.492 342.536 125.166 342.536 124.765V117.952H335.824C335.422 117.952 335.096 117.626 335.097 117.225C335.097 116.823 335.423 116.497 335.824 116.497C335.824 116.497 335.824 116.497 335.825 116.497H343.264C343.457 116.497 343.642 116.574 343.778 116.711C343.915 116.848 343.991 117.033 343.991 117.225V124.765C343.991 125.166 343.666 125.492 343.264 125.492Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.922 174.332L288.702 187.43C290.717 186.397 292.53 184.895 293.947 182.932C294.859 181.67 295.542 180.313 296.005 178.909L281.922 174.332Z",
    fill: "#DDDDDD",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.203 173.748L267.202 173.748C267.313 175.105 267.065 174.698 267.388 176.667C267.999 180.381 270.015 183.864 273.307 186.247L281.922 174.332L279.57 159.69C272.578 160.841 267.445 166.758 267.203 173.748Z",
    fill: "#3B94EC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.922 174.332L273.307 186.247L273.311 186.247C277.963 189.612 283.914 189.872 288.702 187.429L281.922 174.332Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.509 160.192L286.487 160.199C284.23 159.476 281.856 159.318 279.57 159.693L281.922 174.332L296.026 178.904C298.586 171.154 294.365 162.715 286.509 160.192Z",
    fill: "#E8F2FC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.75 226.312C105.75 225.214 105.971 224.356 106.427 223.74C106.88 223.129 107.385 222.719 107.948 222.518C108.513 222.313 109.027 222.216 109.503 222.216C110.455 222.216 111.324 222.536 112.11 223.176C112.885 223.816 113.276 224.861 113.276 226.312C113.276 226.917 113.163 227.532 112.937 228.158C112.711 228.779 112.315 229.309 111.747 229.75C111.185 230.196 110.435 230.414 109.503 230.414C109.082 230.414 108.652 230.347 108.221 230.215C107.799 230.08 107.391 229.856 107.017 229.54C106.641 229.222 106.334 228.795 106.097 228.254C105.863 227.718 105.75 227.075 105.75 226.312ZM107.904 226.319C107.904 227.18 108.069 227.808 108.404 228.203C108.739 228.594 109.106 228.795 109.502 228.795C109.901 228.795 110.267 228.595 110.6 228.203C110.937 227.808 111.099 227.18 111.099 226.319C111.099 225.682 111.008 225.18 110.83 224.816C110.658 224.448 110.444 224.194 110.197 224.051C109.955 223.908 109.727 223.838 109.502 223.838C109.274 223.838 109.042 223.908 108.804 224.051C108.557 224.194 108.347 224.448 108.166 224.816C107.993 225.181 107.904 225.682 107.904 226.319ZM108.804 236.832L117.945 222.481H121.232L112.081 236.832H108.804ZM117.05 232.996C117.05 231.558 117.442 230.513 118.225 229.865C119.005 229.222 119.878 228.899 120.83 228.899C121.775 228.899 122.64 229.222 123.42 229.865C124.203 230.513 124.594 231.558 124.594 232.996C124.594 234.005 124.393 234.815 123.996 235.427C123.601 236.041 123.113 236.471 122.538 236.722C121.965 236.975 121.391 237.098 120.83 237.098C120.259 237.098 119.684 236.972 119.106 236.72C118.529 236.468 118.044 236.035 117.644 235.424C117.246 234.809 117.05 233.999 117.05 232.996ZM119.222 232.996C119.222 233.825 119.384 234.442 119.703 234.856C120.021 235.268 120.395 235.477 120.83 235.477C121.042 235.477 121.277 235.406 121.523 235.264C121.766 235.124 121.978 234.872 122.154 234.502C122.332 234.133 122.417 233.632 122.417 232.996C122.417 232.124 122.253 231.494 121.923 231.102C121.587 230.712 121.222 230.514 120.83 230.514C120.378 230.514 119.998 230.729 119.689 231.162C119.381 231.595 119.222 232.204 119.222 232.996Z",
    fill: "#D5E3EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.885 292.177C428.885 293.675 427.671 294.888 426.174 294.888H383.165C381.668 294.888 380.454 293.675 380.454 292.177V262.632H428.885V292.177Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.623 262.632C413.638 262.632 413.648 262.632 413.648 262.632C412.897 258.328 409.14 255.042 404.622 255.042C400.106 255.042 396.351 258.328 395.599 262.632",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.623 262.632C413.638 262.632 413.648 262.632 413.648 262.632C412.897 258.328 409.14 255.042 404.622 255.042C400.106 255.042 396.351 258.328 395.599 262.632",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.885 262.632H380.454V262.955C382.654 274.402 392.716 283.053 404.805 283.053C426.083 283.052 428.885 262.632 428.885 262.632Z",
    fill: "#DDDDDD",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.621 283.593C395.621 284.193 395.135 284.677 394.536 284.677H392.02C391.421 284.677 390.935 284.193 390.935 283.593V278.985C390.935 278.387 391.421 277.902 392.02 277.902H394.536C395.135 277.902 395.621 278.387 395.621 278.985V283.593Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.391 283.593C418.391 284.193 417.905 284.677 417.306 284.677H414.789C414.19 284.677 413.705 284.193 413.705 283.593V278.985C413.705 278.387 414.19 277.902 414.789 277.902H417.306C417.905 277.902 418.391 278.387 418.391 278.985V283.593Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.951 130.028C294.388 130.028 293.963 130.268 293.646 130.686L293.645 130.684C293.558 130.802 293.421 130.879 293.267 130.879C293.067 130.879 292.898 130.753 292.829 130.575V126.199V126.194H288.591C288.354 126.166 288.168 125.968 288.168 125.725C288.168 125.568 288.244 125.431 288.362 125.344L288.359 125.343C288.776 125.022 289.016 124.595 289.016 124.028C289.016 123.088 288.251 122.326 287.307 122.326C286.363 122.326 285.597 123.088 285.597 124.028C285.597 124.595 285.837 125.022 286.254 125.343L286.252 125.344C286.369 125.431 286.445 125.568 286.445 125.725C286.445 125.968 286.26 126.167 286.023 126.194H281.784V126.196H281.794V130.398C281.794 130.661 282.006 130.877 282.266 130.877C282.421 130.877 282.558 130.8 282.644 130.682L282.645 130.684C282.963 130.266 283.388 130.025 283.951 130.025C284.885 130.025 285.641 130.793 285.641 131.742C285.641 132.69 284.885 133.458 283.951 133.458C283.388 133.458 282.963 133.218 282.645 132.799L282.644 132.8C282.558 132.684 282.421 132.608 282.266 132.608C282.006 132.608 281.794 132.822 281.794 133.086V137.287H281.784V137.289H286.023C286.26 137.316 286.445 137.514 286.445 137.758C286.445 137.914 286.369 138.053 286.252 138.139L286.254 138.141C285.837 138.461 285.597 138.888 285.597 139.456C285.597 140.395 286.363 141.157 287.307 141.157C288.251 141.157 289.016 140.395 289.016 139.456C289.016 138.888 288.776 138.461 288.359 138.141L288.362 138.139C288.244 138.053 288.168 137.915 288.168 137.758C288.168 137.515 288.354 137.316 288.591 137.289H292.795H292.829V137.284V132.913C292.898 132.736 293.068 132.61 293.267 132.61C293.421 132.61 293.558 132.686 293.645 132.804L293.646 132.802C293.964 133.221 294.388 133.461 294.951 133.461C295.885 133.461 296.641 132.692 296.641 131.744C296.641 130.796 295.885 130.028 294.951 130.028Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.635 183.834L152.177 181.327V180.536L149.635 177.996H154.699L157.234 180.536V181.327L154.699 183.834H149.635Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 180.949C196 191.199 187.694 199.509 177.444 199.509C167.193 199.509 158.881 191.199 158.881 180.949C158.881 170.699 167.193 162.391 177.444 162.391C187.694 162.391 196 170.699 196 180.949Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.349 180.949C193.349 189.734 186.227 196.856 177.444 196.856C168.659 196.856 161.531 189.734 161.531 180.949C161.531 172.163 168.659 165.041 177.444 165.041C186.227 165.041 193.349 172.163 193.349 180.949Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.676 180.949C190.676 188.259 184.749 194.186 177.444 194.186C170.133 194.186 164.206 188.259 164.206 180.949C164.206 173.639 170.133 167.714 177.444 167.714C184.748 167.714 190.676 173.64 190.676 180.949Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.906 180.865C187.906 186.691 183.182 191.415 177.354 191.415C171.526 191.415 166.806 186.691 166.806 180.865C166.806 175.04 171.526 170.318 177.354 170.318C183.182 170.318 187.906 175.04 187.906 180.865Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.421 180.865C185.421 185.322 181.809 188.933 177.354 188.933C172.899 188.933 169.286 185.322 169.286 180.865C169.286 176.412 172.899 172.798 177.354 172.798C181.809 172.798 185.421 176.412 185.421 180.865Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.882 180.865C182.882 183.919 180.407 186.394 177.355 186.394C174.301 186.394 171.83 183.919 171.83 180.865C171.83 177.813 174.301 175.339 177.355 175.339C180.407 175.338 182.882 177.813 182.882 180.865Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.569 180.865C180.569 182.642 179.135 184.082 177.355 184.082C175.581 184.082 174.138 182.642 174.138 180.865C174.138 179.091 175.581 177.65 177.355 177.65C179.135 177.65 180.569 179.091 180.569 180.865Z",
    fill: "#3B94EC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M175.794 180.262L163.174 192.938L163.853 193.671L176.328 181.25L175.794 180.262Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.604 180.882C176.604 181.192 176.349 181.446 176.041 181.446H152.124V180.317H176.041C176.349 180.317 176.604 180.571 176.604 180.882Z",
    fill: "#010200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.137 223.377C427.356 224.158 426.074 224.142 425.272 223.342L417.279 215.349C416.666 214.734 416.585 214.106 417.134 213.559L418.211 212.481C418.906 211.785 419.521 211.851 420.149 212.478L428.143 220.473C428.944 221.273 428.959 222.556 428.177 223.338L428.137 223.377Z",
    fill: "#3B94EC",
    stroke: "#010200",
    strokeWidth: 1.50376
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.251 207.379C423.251 213.422 418.355 218.319 412.312 218.319C406.27 218.319 401.371 213.422 401.371 207.379C401.371 201.338 406.27 196.44 412.312 196.44C418.354 196.44 423.251 201.338 423.251 207.379Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.299 207.381C420.299 211.79 416.723 215.368 412.311 215.368C407.9 215.368 404.324 211.79 404.324 207.381C404.324 202.968 407.9 199.393 412.311 199.393C416.723 199.393 420.299 202.968 420.299 207.381Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.411 206.878C407.382 207.157 407.156 207.381 406.876 207.381C406.589 207.381 406.364 207.134 406.389 206.848C406.645 203.984 408.94 201.699 411.808 201.457C412.086 201.433 412.312 201.666 412.312 201.945C412.312 202.234 412.069 202.452 411.781 202.483C409.478 202.731 407.646 204.57 407.411 206.878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.34 227.851H355.449V234.013H358.34V227.851Z",
    fill: "#D8DBD7",
    stroke: "#010200",
    strokeWidth: 1.50376
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.319 244.459C370.319 251.931 364.263 257.987 356.792 257.987C349.321 257.987 343.265 251.931 343.265 244.459C343.265 236.988 349.321 230.932 356.792 230.932C364.263 230.931 370.319 236.988 370.319 244.459Z",
    fill: "#3B94EC",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.061 228.789C361.061 229.291 360.654 229.698 360.152 229.698H353.638C353.135 229.698 352.729 229.291 352.729 228.789V227.123C352.729 226.62 353.136 226.214 353.638 226.214H360.152C360.654 226.214 361.061 226.62 361.061 227.123V228.789Z",
    fill: "#D8DBD7",
    stroke: "#010200",
    strokeWidth: 1.50376
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.445 244.5C367.47 238.618 362.721 233.83 356.838 233.805C350.955 233.78 346.166 238.529 346.141 244.411C346.116 250.293 350.865 255.081 356.748 255.106C362.631 255.131 367.42 250.382 367.445 244.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.391 244.168C357.391 244.499 357.123 244.767 356.792 244.767C356.462 244.767 356.192 244.499 356.192 244.168V239.837C356.192 239.506 356.462 239.238 356.792 239.238C357.123 239.238 357.391 239.506 357.391 239.837V244.168Z",
    fill: "#010200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.338 244.426C363.338 244.615 363.184 244.767 362.996 244.767H356.534C356.346 244.767 356.192 244.615 356.192 244.426C356.192 244.238 356.346 244.084 356.534 244.084H362.996C363.184 244.085 363.338 244.238 363.338 244.426Z",
    fill: "#010200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.996 245.018H356.533C356.207 245.018 355.941 244.752 355.941 244.426C355.941 244.099 356.207 243.834 356.533 243.834H362.996C363.322 243.834 363.588 244.099 363.588 244.426C363.588 244.752 363.322 245.018 362.996 245.018ZM356.533 244.335C356.483 244.335 356.443 244.376 356.443 244.426C356.443 244.477 356.483 244.517 356.533 244.517H362.996C363.046 244.517 363.087 244.477 363.087 244.426C363.087 244.376 363.046 244.335 362.996 244.335H356.533Z",
    fill: "#010200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.391 235.553C357.391 235.884 357.123 236.153 356.792 236.153C356.462 236.153 356.192 235.884 356.192 235.553V235.028C356.192 234.697 356.462 234.428 356.792 234.428C357.123 234.428 357.391 234.697 357.391 235.028V235.553Z",
    fill: "#010200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.391 254.014C357.391 254.345 357.123 254.615 356.792 254.615C356.462 254.615 356.192 254.345 356.192 254.014V253.489C356.192 253.158 356.462 252.89 356.792 252.89C357.123 252.89 357.391 253.158 357.391 253.489V254.014Z",
    fill: "#010200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.824 243.922C348.154 243.922 348.424 244.19 348.424 244.521C348.424 244.852 348.154 245.12 347.824 245.12H347.299C346.968 245.12 346.7 244.852 346.7 244.521C346.7 244.19 346.968 243.922 347.299 243.922H347.824Z",
    fill: "#010200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.285 243.922C366.616 243.922 366.885 244.19 366.885 244.521C366.885 244.852 366.616 245.12 366.285 245.12H365.76C365.43 245.12 365.161 244.852 365.161 244.521C365.161 244.19 365.43 243.922 365.76 243.922H366.285Z",
    fill: "#010200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.1 244.459C358.1 245.182 357.515 245.768 356.792 245.768C356.07 245.768 355.484 245.182 355.484 244.459C355.484 243.737 356.07 243.152 356.792 243.152C357.515 243.151 358.1 243.736 358.1 244.459Z",
    fill: "#D8DBD7",
    stroke: "#010200",
    strokeWidth: 1.50376
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.408 220.464L318.388 215.702L313.793 222.636L318.555 227.064L326.408 220.464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.367 211.775L138.688 215.619L139.357 220.715L145.372 216.621L143.367 211.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.145 133.328C188.145 128.725 184.501 124.993 180.004 124.993C175.507 124.993 171.863 128.724 171.863 133.328C171.863 136.174 173.255 138.685 175.383 140.188C175.71 140.421 175.938 140.79 175.938 141.199V143.963C175.938 145.19 176.909 145.087 178.107 145.087H181.902C183.099 145.087 184.07 145.19 184.07 143.963V141.199C184.07 140.791 184.298 140.421 184.627 140.188C186.753 138.684 188.145 136.173 188.145 133.328Z",
    fill: "#3381E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.404 136.816V142.49",
    stroke: "white",
    strokeWidth: 1.50376,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.476 136.336V142.49",
    stroke: "white",
    strokeWidth: 1.50376,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.25 146.962C182.25 148.295 181.195 149.375 179.893 149.375C178.592 149.375 177.537 148.295 177.537 146.962C177.537 145.63 178.592 145.645 179.893 145.645C181.195 145.645 182.25 145.63 182.25 146.962Z",
    fill: "#3381E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.935 142.118V144.701C175.935 145.571 176.63 146.279 177.485 146.279H182.523C183.38 146.279 184.073 145.571 184.073 144.701V142.118H175.935Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.39 136.311C178.114 136.526 177.783 136.642 177.433 136.642C176.565 136.642 175.858 135.918 175.858 135.028C175.858 134.139 177.387 132.342 179.898 135.036C180.929 136.103 181.473 136.642 182.336 136.642C183.204 136.642 183.911 135.918 183.911 135.028C183.911 134.139 183.204 133.415 182.336 133.415C181.986 133.415 181.655 133.529 181.379 133.746",
    stroke: "white",
    strokeWidth: 1.50376,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.991 133.135H167.812",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.135 133.135H195.956",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.672 144.437L171.374 141.735",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.574 124.536L191.275 121.834",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.974 120.972V117.153",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.275 144.437L188.574 141.735",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.374 124.535L168.672 121.834",
    stroke: "black",
    strokeWidth: 1.50376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_837_236",
    x: 0.0373135,
    y: 0.0373135,
    width: 460.925,
    height: 310.925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.98134
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_837_236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_837_236",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_837_236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 422,
    height: 284.175,
    fill: "white",
    transform: "translate(19 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDvtBenefits2);
export default __webpack_public_path__ + "static/media/dvt_benefits2.94837dbd9539cf5baf0b383f11caf3e6.svg";
export { ForwardRef as ReactComponent };